import { render, staticRenderFns } from "./item.vue?vue&type=template&id=bc9e6b6c&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"
import style0 from "./item.vue?vue&type=style&index=0&id=bc9e6b6c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9e6b6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc9e6b6c')) {
      api.createRecord('bc9e6b6c', component.options)
    } else {
      api.reload('bc9e6b6c', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=bc9e6b6c&scoped=true", function () {
      api.rerender('bc9e6b6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabCalendar/components/item.vue"
export default component.exports